import React, { ReactNode } from 'react';
import ReactModal from 'react-modal';
import { Modals } from '../../context/modal/modalTypes';
import useModalState from '../../context/modal/useModalState';

type Props = {
    modalName: keyof Modals;
    className?: string;
    shouldCloseOnOverlayClick?: boolean;
    overlayClassName?: string;
    children: ReactNode;
    onCloseCallback?: () => void;
};

const CustomModal: React.FC<Props> = ({
    modalName,
    shouldCloseOnOverlayClick = true,
    className = '',
    overlayClassName = '',
    children,
    onCloseCallback,
}) => {
    const { modal, closeModal } = useModalState();

    const onClose = () => {
        onCloseCallback && onCloseCallback();
        closeModal(modalName);
    };

    const otherModalOpen = Object.values(modal).includes(true);

    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={modal[modalName]}
            overlayClassName={`modal-overlay ${overlayClassName ?? ''}`}
            className='modal-content'
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
            onRequestClose={onClose}
            onAfterOpen={() => (document.body.style.overflow = 'hidden')}
            onAfterClose={() =>
                !otherModalOpen && (document.body.style.overflow = 'unset')
            }
        >
            <div
                className='blur-background'
                onClick={shouldCloseOnOverlayClick ? onClose : undefined}
            />
            <div className={`modal-content-inner card card-primary ${className ?? ''}`}>
                {children}
            </div>
        </ReactModal>
    );
};

export default CustomModal;
